import {loadEcharts, loadColorThiefJS} from './js';
import {loadJS, createLoadLibObservable} from './util';

export const echarts$ = createLoadLibObservable({
  id: 'echarts',
  loadJs: loadEcharts,
});

export const colorthief$ = createLoadLibObservable({
  id: 'ColorThief',
  loadJs: loadColorThiefJS,
});

export const depositPortal$ = createLoadLibObservable({
  id: 'DepositPortal',
  loadJs: () => loadJS('deposit-portal', 'https://static.phemex.com/s/web/deposit/deposit-portal@1.0.5.umd.js'),
});

export const remoteHeader$ = createLoadLibObservable({
  id: 'RemoteHeader',
  loadJs: () => loadJS('remote-header', 'https://static.phemex.com/s/web/js/remote-header@1.0.14.umd.js'),
});
